import React from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Paper
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';
import useListagemCifaStore from 'stores/cifa/listagemCifa.store';
import { CifaStatusEnum } from 'enum/cifaStatus.enum';

interface FiltersCifaProps {
  onApplyFilters: () => void;
  year: number;
}

const statusOptions = [
  { value: '', label: 'TODOS' },
  { value: CifaStatusEnum.NOT_STARTED, label: 'NÃO INICIADO' },
  { value: CifaStatusEnum.PENDING, label: 'PENDENTE' },
  { value: CifaStatusEnum.WAITING_FOR_APPROVAL, label: 'ENVIADO AO ESTADO' }
];

export const FiltersCifa: React.FC<FiltersCifaProps> = ({ onApplyFilters, year }) => {
  const { filtros, setFiltros, clearFiltros, getListCifas } = useListagemCifaStore();

  const handleFilterChange = (field: keyof typeof filtros, value: string) => {
    // Força texto em maiúsculas no campo de Prefeitura
    const processedValue = field === 'institution' ? (value ?? '').toUpperCase() : value;
    setFiltros({
      ...filtros,
      [field]: processedValue
    });
  };

  const handleClearFilters = () => {
    clearFiltros();
    getListCifas(year);
  };

  const handleApplyFilters = () => {
    onApplyFilters();
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Prefeitura"
            variant="outlined"
            value={filtros.institution}
            onChange={(e) => handleFilterChange('institution', e.target.value)}
            placeholder="Digite o nome da prefeitura"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              style: { textTransform: 'uppercase' },
            }}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="status-filter-label" shrink>Status</InputLabel>
            <Select
              labelId="status-filter-label"
              id="status-filter"
              value={filtros.formulario_status ?? ''}
              onChange={(e) => handleFilterChange('formulario_status', e.target.value)}
              label="Status"
              displayEmpty
              renderValue={(selected) => {
                if (selected === '' || selected === undefined || selected === null) return 'TODOS';
                const option = statusOptions.find((o) => o.value === selected);
                return option ? option.label : String(selected);
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Responsável"
            variant="outlined"
            value={filtros.responsavel}
            onChange={(e) => handleFilterChange('responsavel', e.target.value)}
            placeholder="Digite o nome do responsável"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Search />}
              onClick={handleApplyFilters}
              fullWidth
            >
              Buscar
            </Button>
            <Button
              variant="outlined"
              startIcon={<Clear />}
              onClick={handleClearFilters}
              fullWidth
            >
              Limpar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FiltersCifa;
